import Message from './src/message.js';
export default Message;